import PartnerStackCarousel from './PartnerStackCarousel.js';
import PartnerCardView from './PartnerCardView.js';
import { useData } from '../context/DataContext.js';

export default function Partners() {
  const { partners, loading, error } = useData();

  if (loading) {
    return (
      <div className="relative isolate px-2 pt-6 lg:px-8 h-full">
        <div className="mx-auto max-w-7xl px-2 lg:px-8 pt-6">
          <p>Loading partners...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="relative isolate px-2 pt-6 lg:px-8 h-full">
        <div className="mx-auto max-w-7xl px-2 lg:px-8 pt-6">
          <p>Error loading partners: {error}</p>
        </div>
      </div>
    );
  }

  // Filter active partners (ensure partners exists before filtering)
  const activePartners = partners?.filter(partner => partner.isPaid === 1) || [];

  return (
    <div className="relative isolate px-2 pt-0 lg:px-8 h-full">
      <div className="mx-auto max-w-7xl px-2 lg:px-8 pt-2 sm:pt-4">
        <div className="sm:flex sm:items-center"></div>
        <div className="mt-2 sm:mt-4">
          {activePartners.length > 0 ? (
            <>
              <PartnerStackCarousel partners={activePartners} />
              <div className="mt-4 sm:mt-6">
                <PartnerCardView partners={activePartners} />
              </div>
            </>
          ) : (
            <p>No active partners found</p>
          )}
        </div>
      </div>
    </div>
  );
}
